/* GYEB 2026-08-15 -- drawer overlay hardening.
   Injected once, from JS, so no other theme file has to be rewritten.
   1. Puts the open drawer above every other fixed element on the page.
   2. Kills pointer events on anything behind the overlay.
   3. Hides the mobile sticky add-to-cart bar while the drawer is open.
   4. Real iOS Safari scroll lock (body{overflow:hidden} alone does not
      stop rubber-band scrolling in Safari or the FB/IG webviews). */
(function () {
  if (document.getElementById('gyeb-drawer-lock-css')) return;
  var css = [
    'html.gyeb-drawer-open cart-drawer.active{z-index:2147482000}',
    'html.gyeb-drawer-open cart-drawer.active #CartDrawer-Overlay{pointer-events:auto;z-index:1}',
    'html.gyeb-drawer-open cart-drawer.active .drawer__inner{z-index:2;position:relative}',
    'html.gyeb-drawer-open .gyeb-sticky-atc{display:none!important;visibility:hidden!important;pointer-events:none!important}',
    'html.gyeb-drawer-open .shopify-section-header,html.gyeb-drawer-open #MainContent{pointer-events:none}',
    'html.gyeb-drawer-open cart-drawer,html.gyeb-drawer-open cart-drawer *{pointer-events:auto}',
    'body.gyeb-scroll-locked{position:fixed;left:0;right:0;width:100%;overflow:hidden}'
  ].join('');
  var tag = document.createElement('style');
  tag.id = 'gyeb-drawer-lock-css';
  tag.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(tag);
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  /* GYEB: iOS-safe scroll lock. Remembers scroll position, pins the body,
     restores on close so the shopper lands back where they were. */
  lockScroll() {
    if (document.documentElement.classList.contains('gyeb-drawer-open')) return;
    this.gyebScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = '-' + this.gyebScrollY + 'px';
    document.documentElement.classList.add('gyeb-drawer-open');
    document.body.classList.add('overflow-hidden', 'gyeb-scroll-locked');
  }

  unlockScroll() {
    if (!document.documentElement.classList.contains('gyeb-drawer-open')) return;
    document.documentElement.classList.remove('gyeb-drawer-open');
    document.body.classList.remove('overflow-hidden', 'gyeb-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, this.gyebScrollY || 0);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    this.lockScroll();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.unlockScroll();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
